import {create} from 'zustand';

type SidebarState = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
  isProfileOpen: boolean;
  setProfileOpen: (isOpen: boolean) => void;
};

export const useSidebarStore = create<SidebarState>((set) => ({
  isOpen: false,
  isProfileOpen: false,
  open() {
    set({isOpen: true});
  },
  close() {
    set({isOpen: false});
  },
  toggle() {
    set((state) => ({isOpen: !state.isOpen}));
  },
  setProfileOpen(isOpen) {
    set({isProfileOpen: isOpen});
  },
}));
